import { z } from "zod";

const baseQuestion = z.object({
  id: z.string().min(1),
  text: z.string().min(1),
  required: z.boolean().optional().default(true),
});

export const ScaleQuestionSchema = baseQuestion.extend({
  type: z.literal("scale"),
  min: z.number().int().min(1),
  max: z.number().int().min(2),
  minLabel: z.string(),
  maxLabel: z.string(),
});

export const ShortAnswerQuestionSchema = baseQuestion.extend({
  type: z.literal("short"),
  placeholder: z.string().optional(),
  maxLength: z.number().int().positive().optional(),
});

export const LongAnswerQuestionSchema = baseQuestion.extend({
  type: z.literal("long"),
  placeholder: z.string().optional(),
  maxLength: z.number().int().positive().optional(),
});

export const QuestionSchema = z.discriminatedUnion("type", [
  ScaleQuestionSchema,
  ShortAnswerQuestionSchema,
  LongAnswerQuestionSchema,
]);

export const SurveySchema = z.object({
  id: z.string().min(1),
  title: z.string().min(1),
  description: z.string().optional(),
  questions: z.array(QuestionSchema).min(1),
});

export type ScaleQuestion = z.infer<typeof ScaleQuestionSchema>;
export type ShortAnswerQuestion = z.infer<typeof ShortAnswerQuestionSchema>;
export type LongAnswerQuestion = z.infer<typeof LongAnswerQuestionSchema>;
export type Question = z.infer<typeof QuestionSchema>;
export type Survey = z.infer<typeof SurveySchema>;

export function parseSurvey(input: unknown): Survey {
  return SurveySchema.parse(input);
}
